import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { getNearToExpireStocks } from "../PharmacyManageStocks/ManageStocksService";

const NearlyExpiredProducts = () => {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const [page] = useState(1);
	const [size] = useState(10);
	const { pharmacyPOS } = usePharmacy();
	const [skeletonLoading, setSkeletonLoading] = useState(false);
	const history = useNavigate();
	const clinicId = pharmacyPOS?.hospital_id;

	useEffect(() => {
		if (!clinicId) return;
		getStocks();
	}, [clinicId]);

	const getStocks = async () => {
		const body = {
			clinicId,
			page,
			limit: size,
			search: ""
		};
		try {
			setSkeletonLoading(true);
			const response = await getNearToExpireStocks(body);
			const stocksData = response?.data?.data || {};
			setData(stocksData.stocks || []);
		} catch (error) {
			console.error("Error fetching nearly expired stocks:", error);
			setData([]);
		} finally {
			setSkeletonLoading(false);
		}
	};

	const formatDate = (dateString) => {
		if (!dateString) return "N/A";
		const date = new Date(dateString);
		const day = date.getDate().toString().padStart(2, "0");
		const month = date.toLocaleString(undefined, { month: "short" });
		const year = date.getFullYear();
		return `${day} ${month} ${year}`;
	};

	const gotoList = () => {
		history(`${process.env.PUBLIC_URL}/near-expire-stock`);
	};

	return (
		<Card className="h-100">
			<CardHeader className="d-flex justify-content-between align-items-center">
				<h6 className="mb-0">{t("Items Expiring Soon")}</h6>
				<button
					type="button"
					onClick={gotoList}
					className="btn btn-link p-0 text-primary small text-underline"
					style={{ textDecoration: "none" }}
				>
					{t("View All")}
				</button>
			</CardHeader>
			<CardBody>
				{skeletonLoading ? (
					<Skeleton count={5} height={30} />
				) : data.length === 0 ? (
					<p className="text-center text-muted">{t("No nearly expired products found")}</p>
				) : (
					<div className="tw-h-[250px]" style={{ overflow: "auto" }}>
						<Table size="sm" striped bordered responsive>
							<thead>
								<tr>
									<th>{t("Product Name")}</th>
									<th style={{ whiteSpace: "nowrap" }}>{t("Expiry Date")}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, idx) => (
									<tr key={item._id || idx}>
										<td>
											<span
												className="d-inline-block text-truncate"
												style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
												title={item.brandName}
											>
												{item.brandName}
											</span>
										</td>
										<td>{formatDate(item.stockData?.[0]?.expiryDate)}</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>
				)}
			</CardBody>
		</Card>
	);
};

export default NearlyExpiredProducts;
